interface IProps {
  forceValue?: boolean;
}

function useIsDev(props?: IProps) {
  if (process.env.NODE_ENV === 'production') return false;

  if (props?.forceValue !== undefined) return props.forceValue;
  return process.env.NODE_ENV === 'development';
}

export default useIsDev;
